module.exports = __webpack_public_path__ + "img/video1.dd94753a.png";